module.exports = __webpack_public_path__ + "img/main_exp.e9664e23.jpg";